
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'

import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import Vuetify from 'vuetify'
import Cookie from 'vue-cookie'
import VueOffline from 'vue-offline'

import Main from '@/assets/javascript/main'

import '@/assets/css/main.css'
import '@/assets/css/icons.css'
import 'vuetify/dist/vuetify.min.css'

import wysiwyg from 'vue-wysiwyg'
import 'vue-wysiwyg/dist/vueWysiwyg.css'

import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'

import serviceWorker from 'serviceworker-webpack-plugin/lib/runtime'

Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)

delete Icon.Default.prototype._getIconUrl

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.use(Cookie)
Vue.use(VueOffline)
Vue.use(Vuetify, {
  theme: {
    primary: '#004d40',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
})

Vue.use(wysiwyg, {})

Vue.config.productionTip = false

/* eslint-disable no-new */
export const myVue = new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})

let version = localStorage.getItem('ApplicationVersion')
if (!version) {
  version = ''
}

let main = new Main(store, router)
main.enforceAuthentication()
main.startSessionChecker()
main.startCommandProcessor()

if ('serviceWorker' in navigator) {
  serviceWorker.register()
}



// WEBPACK FOOTER //
// ./src/main.js